import React, { Fragment } from 'react'

const SocialIcon = [
    {
        icon: 'fab fa-facebook-f',
        href: 'https://www.facebook.com/codam.group/',
        ariaLabel: '페이스북',
    },
    {
        icon: 'fab fa-twitter',
        href: 'https://x.com/codam_official',
        ariaLabel: 'X(트위터)',
    },
    {
        icon: 'fab fa-linkedin-in',
        href: 'https://www.linkedin.com/',
        ariaLabel: '링크드인',
    },
    {
        icon: 'fab fa-youtube',
        href: 'https://youtube.com/@codam-kr-official',
        ariaLabel: '유튜브',
    },
    {
        icon: 'fab fa-telegram-plane',
        href: 'https://t.me/CODAM_KR_Official',
        ariaLabel: '텔레그램',
    },
    {
        icon: 'fab fa-instagram',
        href: 'https://instagram.com/codam.kr.official',
        ariaLabel: '인스타그램',
    },
]

const SocialOne = () => {
    return (
        <Fragment>
            <div className="footer__social mb-30">
                {SocialIcon.map((val, i) => (
                    <a
                        key={i}
                        href={val.href}
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label={val.ariaLabel}
                    >
                        <i className={val.icon} aria-hidden="true" />
                    </a>
                ))}
            </div>
        </Fragment>
    )
}

export default SocialOne
